import z from 'zod'
import type { Tables } from '../db/supabase.types.ts'

export type RealtorProfile = {
  name: string | null
  slug: string | null
  data: {
    email?: string | null
    phone_number?: string | null
    company?: string | null
    avatar_url?: string | null
  } | null
}

export const assetRelationDataSchema = z.object({
  listingLink: z.string().nullish(),
  listingDate: z.string().nullish(),
  saleDate: z.string().nullish(),
  notes: z.string().nullish(),
})

export const assetRelationTypes = ['prospect', 'representation', 'reference'] as const

export const assetRelationTypeSchema = z.enum(assetRelationTypes)

export type AssetRelationType = (typeof assetRelationTypes)[number]

export type ParsedAssetRelation = Omit<
  Tables<'users_assets'>,
  'data' | 'asset_id' | 'created_at' | 'updated_at'
> & {
  data?: z.infer<typeof assetRelationDataSchema> | null
  realtor?: RealtorProfile | null
  is_own?: boolean
  asset_id?: string
  created_at?: string
  updated_at?: string
}
